define('shared/my/cmus',[
    'shared/lib/cookie',
    'shared/lib/RSVP'
], function(cookie, RSVP){
    'use strict';
    return function() {
        return RSVP.resolve(cookie.get('CMus'));
    };
});
